<!-- VIP -->
<template>
  <div class="vip">
    <div class="wrap more-rights">
      <div class="list">
        <div class="item">
          <img src="@/assets/vip/right-more-1.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">会员故事畅听</h2>
            <p class="desc">VIP会员畅听，7000部、10万集有声作品。在有效期内可畅听：包含经典童话故事、大奖绘本、各类儿童故事、英语磨耳、英语知识、科普知识、必读名著、历史国学知识等。不仅听故事，还能学知识！</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-2.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">每月重磅作品</h2>
            <p class="desc">月均上新20部作品，知名IP不断引入，可听的内容不断扩充；每周精选VIP专题，不再选择焦虑。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-3.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">非VIP内容折扣</h2>
            <p class="desc">由于内容提供方版权问题，我们有部分故事不属于VIP畅听内容，如果您需要听这些内容，口袋故事也为尊贵的VIP用户争取到单购折扣，最低可至5折。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-4.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">VIP专享优惠</h2>
            <p class="desc">VIP除了VIP专享折扣之外，购买单购故事或VIP续期，都可以再叠加使用优惠券。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-5.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">签到双倍贝壳</h2>
            <p class="desc">贝壳可以在口袋故事的兑换中心兑取小朋友们喜爱的故事机、儿童手表、书籍、文具、以及丰富的生活和学习用品。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-6.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">1对1客户服务</h2>
            <p class="desc">会员尊贵服务：微信添加好友"koudai020"，为您解答所有使用过程中的困惑！</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-7.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">独家内容抢先听</h2>
            <p class="desc">口袋故事有1000多部正版独家作品，会员都可以畅听。</p>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/vip/right-more-8.png" alt="" class="pic">
          <div class="info">
            <h2 class="item-title">不定期福利</h2>
            <p class="desc">关注公众号“口袋故事福利社”，回复“充电”，即可获得价值495元的学习充电大礼包。内容包含古诗词、英语课、名著故事和父母课堂等内容。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created () {
    
  },
  mounted () {

  },
  methods: {
    
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.more-rights {
  padding-top: .24rem;
  padding-bottom: .5rem;
  background: #fff;
  .title {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .all-rights {
      display: inline-flex;
      align-items: center;
      font-size: .28rem;
      color: #a0a0a6;
      .icon-more {
        margin-left: .06rem;
        width: .16rem;
        height: .32rem;
        transform: translateY(.02rem);
      }
    }
  }
  .list {
    padding: 0 .5rem;
    .item {
      display: flex;
      align-items: center;
      margin-bottom: .5rem;
      .pic {
        width: 2.16rem;
      }
      .info {
        flex: 1;
        margin-left: .24rem;
        .item-title {
          margin-bottom: .2rem;
          font-size: .36rem;
          color: #665a57;
        }
        .desc {
          line-height: 1.5;
          color: #a0a0a6;
          font-size: .24rem;
          text-align: justify;
        }
      }
    }
  }
}

</style>
